import styled from '@emotion/styled';

// Card Wrapper
export const CardWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

// Promotion Card
export const Card = styled.div`
  display: flex;
  min-width: 320px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 12px;
  border: ${(props) =>
    props.isSelected ? '2px solid #669F2A' : '1px solid #EBEBEB'};
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
  background: #ffffff;

  &:hover {
    border-color: ${(props) => (props.isSelected ? '#669F2A' : '#3f621a')};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  /* Mobile View (< 1400px) */
  @media (max-width: 1400px) {
    flex-direction: column; /* Stacks items vertically */
    height: auto;
  }
`;

export const SuggestedBadge = styled.div`
  position: absolute;
  top: -9px;
  right: -25px;
  border-radius: 12px;
  z-index: 10;
  color: rgba(63, 98, 26, 1);
  background: rgba(206, 234, 176, 1);
  transform: rotate(12deg);
  border: 1px solid #ceebb0;
  padding: 4px 12px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: Inter, sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.div`
  width: 215px;
  min-width: 215px;
  height: 215px;
  aspect-ratio: 1/1;
  border-radius: 12px 0 0 12px;
  background: #e1e1e1;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Mobile View (< 1400px) */
  @media (max-width: 1400px) {
    width: 100%; /* Take full width of the card */
    min-width: 100%;
    height: 220px; /* Fixed height for the banner look */
    border-radius: 12px 12px 0 0; /* Round top corners only */
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 16px 16px 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 200px;

  /* Mobile View (< 1400px) */
  @media (max-width: 1400px) {
    width: 100%; /* Ensure content takes full width */
    min-height: auto; /* Allow height to adjust to content */
    padding: 24px;
    box-sizing: border-box; /* Ensures padding doesn't break width */
  }
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #181d27;
  margin: 0 0 8px 0;
  @media (max-width: 1020px) {
    font-weight: 500 !important;
  }
`;

export const Price = styled.div`
  font-size: 16px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  color: #181d27;
  margin-bottom: 12px;
  @media (max-width: 1020px) {
    font-weight: 700 !important;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #656565;
  font-weight: 400;
  font-style: normal;

  @media (max-width: 1020px) {
    font-weight: 600;
  }

  @media (max-width: 1020px) {
    ul {
      font-weight: 400;
      color: #656565 !important;
    }
    li {
      font-weight: 400;
      font-size: 14px !important;
      color: #656565 !important;
    }
    span,
    p {
      color: #414651;
      font-size: 14px !important;
      font-weight: 400;
    }
  }

  ul {
    margin: 4px 0;
    padding-left: 20px;
  }

  li {
    line-height: 20px;
  }

  span,
  p {
    font-size: 14px;
    color: #656565;
    line-height: 20px;
    font-weight: normal;
    font-family: Inter, sans-serif;
    margin: 0 !important;
  }
`;

// Info Box (shown when promotion is selected)
export const InfoBox = styled.div`
  background: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
  gap: 12px;
`;

export const InfoIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e8f0dc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 32px;
    height: 32px;
    color: #3f621a;
  }
`;

export const InfoContent = styled.div`
  font-size: 14px;
  color: #535862;
  line-height: 1.5;

  strong {
    color: #181d27;
  }
`;
